import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { apiUrl, imageUrl } from "../Config/apiUrl";

const AddAndEditCmsSourcesModal = ({
  title,
  type,
  visibleModal,
  itemTitle,
  setItemTitle,
  itemLink,
  setItemLink,
  icon,
  iconDisplay,
  onPress,
  onPressCancel,
  itemLoading,
  uploadImages,
}) => {
  return (
    <Modal
      className="modal-dialog-centered custom-addLang-modal"
      isOpen={visibleModal}
      toggle={onPressCancel}
    >
      <div className="modal-Header">
        <h2 className="text-center">{title}</h2>
      </div>
      <div className="addlang-modalBody">
        {itemTitle !== undefined && (
          <div className="innerContainer">
            <div className="form-group">
              <input
                type="text"
                placeholder="Add Name"
                value={itemTitle}
                onChange={(e) => setItemTitle(e.target.value)}
              />
            </div>
          </div>
        )}
        {itemLink !== undefined && (
          <div className="innerContainer">
            <div className="form-group">
              <input
                type="text"
                placeholder="Add Link"
                value={itemLink}
                onChange={(e) => setItemLink(e.target.value)}
              />
            </div>
          </div>
        )}
        {icon !== undefined && (
          <div className="innerContainer">
            <div className="form-group">
              <div className="icon-upload-avatar">
                {icon == "" ? (
                  <>
                    <span>
                      <i className="fa fa-upload" style={{ fontSize: 50 }} />
                      <p>Upload Photo</p>
                    </span>
                  </>
                ) : iconDisplay !== null ? (
                  <img
                    src={iconDisplay}
                    alt="User Image"
                    className="image-fluid"
                  />
                ) : (
                  <img
                    src={`${imageUrl}/${icon}`}
                    alt="User Image"
                    className="image-fluid"
                  />
                )}
                <input
                  type="file"
                  id="InputCoverImage"
                  accept="image/png, image/jpeg"
                  onChange={(e) => uploadImages(e)}
                />
              </div>

              {/* <input
              type="file"
              accept="image/png, image/jpeg"
              onChange={(e) => uploadImages(e)}
            /> */}
            </div>
          </div>
        )}
        <div className="modal-footer footer-div">
          <div>
            <Button
              className="btn btn-user btn-block btn-cancel"
              onClick={onPressCancel}
            >
              Cancel
            </Button>
          </div>

          <div>
            <Button
              className="btn btn-user btn-block btn-save"
              onClick={onPress}
              disabled={itemLoading}
            >
              {itemLoading ? "Loading.." : "Save"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddAndEditCmsSourcesModal;
